export const env = 'development';

export const server = 'http://app.redesdevalor.com';

export const graphql_public_url = server+'/graphql';
export const graphql_webapp_url = server+'/graphql?key=webapp';